import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { AlertTriangle as AlertTriangleIcon } from 'react-feather'

import dponetLogo from 'images/dponet-logo-white.svg'
import { ReactComponent as HexagonDetail } from 'images/hexagon-background-auth.svg'
import constants from 'constants'
import useCustomTheme from 'hooks/useCustomTheme'
import useFetch from 'hooks/useFetch'
import usePhishing from 'hooks/usePhishing'
import * as service from 'service'
import styles from './styles'

const { CARDS } = constants.phishing

const PhishingWarning = () => {
  const { customLogo, customPalette } = useCustomTheme()
  const primaryColor = customPalette?.clientPortalTheme?.primaryColor
  const secondaryColor = customPalette?.clientPortalTheme?.secondaryColor
  const classes = styles({ primaryColor, secondaryColor })()

  const { phishing } = usePhishing()

  const { response: courseResponse } = useFetch(
    service.dponet.trainingCourse.show,
    { courseId: phishing?.trainingId },
    [phishing?.trainingId],
    !!phishing?.trainingId,
  )

  const course = courseResponse?.data?.course

  return (
    <Box className={classes.root}>
      <Box component="header" className={classes.header}>
        <img
          src={customLogo || dponetLogo}
          alt="DPOnet"
          className={classes.logo}
        />
      </Box>

      <Box className={classes.heroSection}>
        <HexagonDetail className={classes.hexTopLeft} />

        <Box className={classes.alertContent}>
          <Box className={classes.alertIconWrapper}>
            <AlertTriangleIcon size={64} className={classes.alertIcon} />
          </Box>

          <Typography className={classes.alertOops}>OOPS!</Typography>

          <Typography className={classes.alertTitle}>
            Você caiu em um phishing simulado!
          </Typography>

          <Typography className={classes.alertDescription}>
            Fique tranquilo, seus dados estão completamente seguros.
            <br />
            Isso foi um teste de conscientização da sua organização.
          </Typography>
        </Box>
      </Box>

      <Box className={classes.infoSection}>
        {!course && (
          <>
            <Typography className={classes.infoTitle}>
              O que você precisa saber sobre phishing:
            </Typography>

            <Box className={classes.cardsContainer}>
              {CARDS.map((card) => (
                <Box key={card.number} className={classes.card}>
                  <Typography className={classes.cardNumber}>
                    {card.number}
                  </Typography>
                  <Typography className={classes.cardTitle}>
                    {card.title}
                  </Typography>
                  <Box className={classes.cardDivider} />
                  <Typography className={classes.cardText}>
                    {card.description}
                  </Typography>
                </Box>
              ))}
            </Box>
          </>
        )}

        {course && (
          <Box className={classes.courseSection}>
            <Typography variant="h4" className={classes.courseHeading}>
              Para se proteger melhor, recomendamos que você assista ao curso
              abaixo:
            </Typography>
            <Box className={classes.courseCard}>
              {course.thumbnailUrl && (
                <img
                  src={course.thumbnailUrl}
                  alt={course.title}
                  className={classes.courseImage}
                />
              )}
              <Typography className={classes.courseName}>
                {course.title}
              </Typography>
              <Box component="span" className={classes.courseButton}>
                Acessar curso
              </Box>
            </Box>
          </Box>
        )}

        <HexagonDetail className={classes.hexBottomRight} />

        <Typography className={classes.footerText}>
          Dúvidas? Entre em contato com o time de segurança da sua organização.
        </Typography>
      </Box>
    </Box>
  )
}

export default PhishingWarning
